import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';

export const hideGraphLayoutDialog: GraphCommandFactory =
  (cmdContext) => () => {
    cmdContext.updateState((draft) => {
      draft.graphLayoutDialog = null;
    });
  };
